import { render, staticRenderFns } from "./EventsHeader.vue?vue&type=template&id=42d2c356&scoped=true&"
import script from "./EventsHeader.vue?vue&type=script&lang=js&"
export * from "./EventsHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventsHeader.vue?vue&type=style&index=0&id=42d2c356&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d2c356",
  null
  
)

export default component.exports